var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: (_vm.dataFrom.sourceId ? _vm.$t("编辑") : _vm.$t("新增")) + _vm.$t("数据源"),
      visible: _vm.dialogVisible,
      okText: _vm.$t("确认"),
      cancelText: _vm.$t("取消"),
      width: 620
    },
    on: {
      ok: _vm.handleSure,
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.dataFrom,
      rules: _vm.dataRule,
      "label-col": {
        span: 6
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "name",
      label: _vm.$t("数据源名称")
    }
  }, [_c("a-input", {
    attrs: {
      maxLength: 50
    },
    model: {
      value: _vm.dataFrom.name,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "name", $$v);
      },
      expression: "dataFrom.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      prop: "mark",
      label: _vm.$t("标识")
    }
  }, [_c("a-input", {
    attrs: {
      maxLength: 100,
      disabled: _vm.dataFrom.sourceId ? true : false
    },
    model: {
      value: _vm.dataFrom.mark,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "mark", $$v);
      },
      expression: "dataFrom.mark"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };